module.exports = __webpack_public_path__ + "img/logo.9893dbb4.png";